import { SearchComponent } from './search.component';
export var searchRoutes = [
    {
        path: 'search',
        component: SearchComponent,
        data: {
            'expectedRoles': ['Accountant', 'Accountant Admin']
        },
    },
];
var SearchRoutingModule = (function () {
    function SearchRoutingModule() {
    }
    return SearchRoutingModule;
}());
export { SearchRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/search/search-routing.module.ts.pre-build-optimizer.js